import React, { useContext, useEffect, useState } from 'react'
import AuthService from '../../../api/services/AuthService';
import { ApiConfig } from '../../../api/apiConfig/apiConfig';
import { $ } from 'react-jquery-plugin';
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import { alertErrorMessage, alertSuccessMessage, alertWarningMessage } from '../../../customComponents/CustomAlertMessage';
import QRCode from 'qrcode.react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ProfileContext } from '../../../context/ProfileProvider';
import './deposit.css';

const DEPOSIT_STATUS_LABEL = {
  PENDING: "Pending",
  COMPLETED: "Completed",
  REJECTED: "Rejected",
};

const depositStatusKey = (status) => String(status || "").toUpperCase();
const depositStatusLabel = (status) => DEPOSIT_STATUS_LABEL[depositStatusKey(status)] || status || "--";
const depositStatusClass = (status) => {
  const key = depositStatusKey(status);
  if (key === "PENDING") return "pending";
  if (key === "COMPLETED") return "completed";
  if (key === "REJECTED") return "rejected";
  return "";
};

const DepositPage = () => {
    const { modalStatus, updateModelHideStatus } = useContext(ProfileContext);
  
  const [availableCurrency, setAvailableCurrency] = useState([]);
  const [allData, setAllData] = useState([]);
  const [searchPair, setSearchPair] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState({});
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [depositAddress, setDepositAddress] = useState("");
  const [recentDepositHistory, setRecentDepositHistory] = useState([]);
  const [allCoinData, setAllCoinData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [depositAddressList, setDepositAddressList] = useState([]);
  const [depositStatusFilter, setDepositStatusFilter] = useState("");
  const [proofAmount, setProofAmount] = useState("");
  const [proofTxHash, setProofTxHash] = useState("");
  const [proofScreenshot, setProofScreenshot] = useState(null);
  const [proofPreview, setProofPreview] = useState("");
  const [submittingProof, setSubmittingProof] = useState(false);

  const depositChains = [...new Map(
    (depositAddressList || [])
      .filter((row) => row?.chain && (!row?.status || String(row.status).toUpperCase() === "ACTIVE"))
      .map((row) => [row.chain, row])
  ).values()];

  const resetProofForm = () => {
    setProofAmount("");
    setProofTxHash("");
    setProofScreenshot(null);
    if (proofPreview) URL.revokeObjectURL(proofPreview);
    setProofPreview("");
  };

  function shortenAddress(address, length = 4) {
    if (!address || address.length < 10) return address; // Ensure it's a valid address
    return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
  }


  const getDepositActiveCoins = async () => {
    LoaderHelper.loaderStatus(true);
    await AuthService.depositActiveCoins().then(async (result) => {
      if (result?.success) {
        try {
          setAvailableCurrency(result?.data)
          setAllData(result?.data)

        } catch (error) {

        }
      }
    });
    LoaderHelper.loaderStatus(false);
  };

  const allCoins = async () => {
    LoaderHelper.loaderStatus(true);
    await AuthService.allCoins().then(async (result) => {
      if (result?.success) {
        try {
          setAllCoinData(result?.data)

        } catch (error) {

        }
      }
    });
    LoaderHelper.loaderStatus(false);
  };

  const fetchDepositRequestList = async (status = depositStatusFilter) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.depositRequestList({
        skip: 0,
        limit: 20,
        status: status || undefined,
      });
      if (result?.success) {
        const list = Array.isArray(result?.data)
          ? result.data
          : (Array.isArray(result?.data?.list) ? result.data.list : []);
        setRecentDepositHistory(list);
      } else {
        setRecentDepositHistory([]);
        if (result?.message) alertErrorMessage(result.message);
      }
    } catch (error) {
      setRecentDepositHistory([]);
      alertErrorMessage("Unable to fetch deposit requests");
    }
    LoaderHelper.loaderStatus(false);
  };

  const handleStatusFilter = (status) => {
    setDepositStatusFilter(status);
    fetchDepositRequestList(status);
  };


  const fetchDepositAddressList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.depositAddressList();
      if (result?.success) {
        const list = Array.isArray(result?.data) ? result.data : [];
        const active = list.filter((row) => !row?.status || String(row.status).toUpperCase() === "ACTIVE");
        setDepositAddressList(active);
        if (!active.length) {
          alertWarningMessage("No deposit networks available");
        }
      } else {
        setDepositAddressList([]);
        alertErrorMessage(result?.message || "Unable to fetch deposit addresses");
      }
    } catch (error) {
      setDepositAddressList([]);
      alertErrorMessage("Unable to fetch deposit addresses");
    }
    LoaderHelper.loaderStatus(false);
  };

  const handleSelectDepositCoin = async (item) => {
    setSelectedCurrency(item);
    setSelectedNetwork("");
    setDepositAddress("");
    setDepositAddressList([]);
    resetProofForm();
    $("#search_coin").modal('hide');
    await fetchDepositAddressList();
  };

  const handleSelectNetwork = async (item) => {
    const chain = typeof item === "string" ? item : item?.chain;
    setSelectedNetwork(chain);
    setDepositAddress("");
    resetProofForm();
    $("#network_pop_up").modal('hide');
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.depositAddressList(chain);
      const list = Array.isArray(result?.data) ? result.data : [];
      const match = list.find((row) =>
        row?.chain === chain && (!row?.status || String(row.status).toUpperCase() === "ACTIVE")
      );
      setDepositAddress(match?.address || "");
      if (!match?.address) {
        alertErrorMessage(result?.message || "No deposit address found for this network");
      }
    } catch (error) {
      setDepositAddress("");
      alertErrorMessage("No deposit address found for this network");
    }
    LoaderHelper.loaderStatus(false);
  };

  const handleProofScreenshot = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 2 * 1024 * 1024;
    if (!allowedTypes.includes(file.type)) {
      alertErrorMessage("Only PNG, JPEG, and JPG screenshots are allowed.");
      return;
    }
    if (file.size > maxSize) {
      alertErrorMessage("Max image size is 2MB.");
      return;
    }
    if (proofPreview) URL.revokeObjectURL(proofPreview);
    setProofScreenshot(file);
    setProofPreview(URL.createObjectURL(file));
  };

  const handleSubmitDepositProof = async () => {
    const shortName = selectedCurrency?.short_name;
    const chain = selectedNetwork;
    const toAddress = depositAddress;
    const amountValue = Number(proofAmount);
    const minDeposit = Number(selectedCurrency?.min_deposit);
    const maxDeposit = Number(selectedCurrency?.max_deposit);

    if (!shortName) {
      alertErrorMessage("Please select a coin");
      return;
    }
    if (!chain) {
      alertErrorMessage("Please select a network");
      return;
    }
    if (!toAddress) {
      alertErrorMessage("Deposit address is missing");
      return;
    }
    if (!proofAmount || Number.isNaN(amountValue) || amountValue <= 0) {
      alertErrorMessage("Amount must be greater than 0");
      return;
    }
    if (!Number.isNaN(minDeposit) && minDeposit > 0 && amountValue < minDeposit) {
      alertErrorMessage(`Minimum deposit is ${minDeposit} ${shortName}`);
      return;
    }
    if (!Number.isNaN(maxDeposit) && maxDeposit > 0 && amountValue > maxDeposit) {
      alertErrorMessage(`Maximum deposit is ${maxDeposit} ${shortName}`);
      return;
    }
    if (!proofTxHash?.trim()) {
      alertErrorMessage("Please enter the transaction hash");
      return;
    }
    if (!proofScreenshot) {
      alertErrorMessage("Please upload a payment screenshot");
      return;
    }

    const formData = new FormData();
    formData.append("short_name", shortName);
    formData.append("chain", chain);
    formData.append("amount", String(amountValue));
    formData.append("to_address", toAddress);
    formData.append("transaction_hash", proofTxHash.trim());
    formData.append("paymentProof", proofScreenshot);

    setSubmittingProof(true);
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.submitDepositProof(formData);
      if (result?.success) {
        alertSuccessMessage("Deposit request submitted — Pending admin approval");
        $("#deposit_proof").modal("hide");
        resetProofForm();
        setDepositStatusFilter("");
        fetchDepositRequestList("");
      } else {
        alertErrorMessage(result?.message || "Unable to submit deposit proof");
      }
    } catch (error) {
      alertErrorMessage("Unable to submit deposit proof");
    }
    LoaderHelper.loaderStatus(false);
    setSubmittingProof(false);
  };


  const handleDepositModal = (item) => {


    const shortToAddress = shortenAddress(item?.to_address);
    const shortTxHash = shortenAddress(item?.transaction_hash);

    setModalData({ ...item, shortTxHash, shortToAddress });

    $("#recent_table").modal('show');

  };


  const copytext = (data) => {
    navigator.clipboard.writeText(data);
    alertSuccessMessage("Copied!!");
  };


  const [announcments, setAnnouncments] = useState([]);
  const handleNotifications = async () => {
    LoaderHelper.loaderStatus(true);
    await AuthService.notifications().then(async (result) => {
      if (result?.data?.length > 0) {
        try {
          let announcement = result?.data?.filter((item) => item?.type === "announcement")
          if (announcement?.length === 1) {
            setAnnouncments([...announcement, ...announcement]);
          } else if (announcement?.length > 1) {
            setAnnouncments(announcement?.reverse());
          }

        } catch (error) {

        }
      }
    });
    LoaderHelper.loaderStatus(false);
  };

  useEffect(() => {
    if (searchPair) {
      const filteredPair = allData?.filter((item) => item?.short_name?.toLowerCase()?.includes(searchPair?.toLowerCase()));
      setAvailableCurrency(filteredPair)

    } else {
      setAvailableCurrency(allData)
    }
  }, [searchPair]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    getDepositActiveCoins()
    allCoins()
    handleNotifications()
    fetchDepositRequestList()

  }, []);
  return (
    <>

      <div className="dashboard_right">
        <div className="deposit_crypto_block_coin">
          <div className="deposit_crypto_left">
            <div className={`select_coin_option ${Object.keys(selectedCurrency).length > 0 && "select-option"}`}>
              <h2>Select Coin</h2>
              <div className="search_icon_s" data-bs-toggle="modal" data-bs-target="#search_coin">
                <i className="ri-search-line"></i> {Object.keys(selectedCurrency).length > 0 ? `${selectedCurrency?.short_name} ${selectedCurrency?.name} ` : "Search Coin"}
              </div>
              {/* <!-- Modal Search Coin Start --> */}

              <div className="modal fade search_form search_coin" id="search_coin" tabIndex="-1" aria-labelledby="exampleModalLabel" >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <input type="text" placeholder="Search coin name " value={searchPair} onChange={(e) => setSearchPair(e.target.value)} />
                      </form>

                      <div className="hot_trading_t">
                        <div className='table-responsive'>
                          <table>
                            <tbody>
                              {availableCurrency?.length > 0 ? availableCurrency?.map((item) => {
                                return (
                                  <tr onClick={() => handleSelectDepositCoin(item)} data-bs-dismiss="modal" >
                                    <td>
                                      <div className="td_first">
                                        <div className="icon"><img src={ApiConfig?.baseImage + item?.icon_path} alt="icon" width="30px" /></div>
                                        <div className="price_heading"> {item?.short_name} <br /> </div>
                                      </div>
                                    </td>
                                    <td className="right_t price_tb">{item?.name}</td>
                                  </tr>
                                )
                              }) : ""}

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Modal Search Coin Start End --> */}

              <div className="coin_items_select">
                {allData?.slice(0, 4)?.map((item) => {
                  return (
                    <div className="coin_items_list" onClick={() => handleSelectDepositCoin(item)} >
                      <img src={ApiConfig?.baseImage + item?.icon_path} alt="icon" />{item?.short_name}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className={`select_network_s ${selectedNetwork && "select-option"}`}>
              <h2>Select Network</h2>
              {Object.keys(selectedCurrency).length > 0 ? <div className="search_icon_s" data-bs-toggle="modal" data-bs-target="#network_pop_up">{selectedNetwork || "Select Network"}</div> : <div className="search_icon_s" >{selectedNetwork || "Select Network"}</div>}

              {/* <div className="d-flex items-center justify-content-between top_space">

                <div className="typography-body3">Contract address ending in</div>
                <a href="#">uSpse {">"}</a>

              </div> */}

              {/* <!-- Modal Network Pop Up Start --> */}

              <div className="modal fade search_form search_coin" id="network_pop_up" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                      <div className="network_top_p">
                        <svg className="bn-svg h-m w-m flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clip-rule="evenodd"
                            d="M12 21a9 9 0 100-18 9 9 0 000 18zm-1.25-5.5V18h2.5v-2.5h-2.5zm0-9.5v7h2.5V6h-2.5z" fill="currentColor">
                          </path></svg>
                        <p>Please note that only supported networks on Vorienxlatform are shown, if you deposit via another
                          network your assets may be lost.  </p>

                      </div>
                      <div className="hot_trading_t">
                        <div className='table-responsive'>
                          <table>
                            <tbody>
                              {depositChains?.length > 0 ? depositChains.map((item) => {
                                return (
                                  <tr key={item?._id || item?.chain} onClick={() => handleSelectNetwork(item)} data-bs-dismiss="modal" >
                                    <td>
                                      <div className="td_first">
                                        <div className="price_heading"> {item?.chain} <br /> <span></span></div>
                                      </div>
                                    </td>
                                    <td className="right_t price_tb">Estimated time<span>≈ 2 mins</span></td>
                                  </tr>

                                )
                              }) : (
                                <tr>
                                  <td colSpan="2">
                                    <p className="mb-0">{Object.keys(selectedCurrency).length > 0 ? "No networks available." : "Select a coin to view networks."}</p>
                                  </td>
                                </tr>
                              )}

                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Modal Network Pop Up End --> */}

            </div>
            <div className="select_network_s ">
              <h2 className={` ${selectedNetwork && "active_input"}`}>Deposit Address</h2>
              {depositAddress ?
                <>
                  <div className="deposit_address_s">

                    <div className="network_top_p">
                      <p>If you deposit via another network your assets may be lost</p>
                    </div>

                    <div className="d-flex items-center justify-content-between scaner_block_s">

                      <div className="typography-body3">

                        <div className="scan_img">
                          <QRCode value={depositAddress} className="qr_img img-fluid" width="50px" />
                          {/* <img src="/images/scan.png" alt="scan" /> */}
                        </div>
                      </div>
                      <div className="scan_cnt_l">
                        <span>Address</span>
                        <address>
                          <p>{depositAddress}</p>

                          <div className="scan_copy" onClick={() => { navigator.clipboard.writeText(depositAddress); alertSuccessMessage("Deposit Address Copied!!"); }}>
                            <svg id="deposit_crypto_address_copy" className="bn-svg icon-normal-pointer qrcode-copy text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path></svg>
                          </div>
                        </address>
                      </div>
                    </div>
                    <div className="deposit_next_wrap login_btn">
                      <input type="button" value="Submit Payment Proof" data-bs-toggle="modal" data-bs-target="#deposit_proof" />
                    </div>
                  </div>


                  <div className="more_btn" data-bs-toggle="modal" data-bs-target="#more_details">
                    More Details {">"}
                  </div>

                </> : selectedNetwork && (
                  <p className="mt-3">No deposit address found for {selectedNetwork}.</p>
                )}

              {/* <!-- Modal scaner more details Pop Up Start --> */}

              <div className="modal fade search_form search_coin" id="more_details" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h2>More Info</h2>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <div className="hot_trading_t">
                        <div className='table-responsive'>
                          <table>
                            <tbody>
                              <tr>
                                <td>Minimum deposit</td>
                                <td className="right_t price_tb"> {selectedCurrency?.min_deposit} {selectedCurrency?.short_name}</td>
                              </tr>
                              <tr>
                                <td>Maximum deposit</td>
                                <td className="right_t price_tb">{selectedCurrency?.max_deposit} {selectedCurrency?.short_name}</td>
                              </tr>
                              <tr>
                                <td>Wallet</td>
                                <td className="right_t price_tb">Spot Wallet</td>
                              </tr>
                              <tr>
                                <td>Credited (Trading enabled)</td>
                                <td className="right_t price_tb">After admin approval</td>
                              </tr>
                              <tr>
                                <td>Do not send NFTs to this address</td>
                              </tr>
                              <tr>
                                <td>Do not transact with Sanctioned Entities</td>
                              </tr>
                              <tr>
                                <td>This is {selectedNetwork} deposit address type. Transferring to an unsupported network could result in loss of deposit.</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Modal  scaner more details Pop Up End --> */}

              <div className="modal fade search_form deposit_proof_modal" id="deposit_proof" tabIndex="-1" aria-labelledby="depositProofLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div className="deposit_proof_head">
                        <div>
                          <h2 id="depositProofLabel">Submit Payment Proof</h2>
                          <p>Share the transaction details so we can credit this deposit.</p>
                        </div>
                      </div>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <div className="deposit_proof_form">
                        <div className="deposit_proof_chips">
                          <div className="deposit_proof_chip">
                            <div className="deposit_proof_chip_icon">
                              {selectedCurrency?.icon_path
                                ? <img src={ApiConfig?.baseImage + selectedCurrency.icon_path} alt="" />
                                : <i className="ri-coin-line"></i>}
                            </div>
                            <div>
                              <small>Coin</small>
                              <strong>{selectedCurrency?.short_name || "--"}</strong>
                            </div>
                          </div>
                          <div className="deposit_proof_chip">
                            <div className="deposit_proof_chip_icon">
                              <i className="ri-share-box-line"></i>
                            </div>
                            <div>
                              <small>Network</small>
                              <strong>{selectedNetwork || "--"}</strong>
                            </div>
                          </div>
                        </div>
                        {depositAddress ? (
                          <div className="deposit_proof_address">
                            <span>Paid to</span>
                            <p title={depositAddress}>{shortenAddress(depositAddress, 6)}</p>
                            <button
                              type="button"
                              className="deposit_proof_copy"
                              onClick={() => { navigator.clipboard.writeText(depositAddress); alertSuccessMessage("Address copied"); }}
                            >
                              <i className="ri-file-copy-line"></i>
                            </button>
                          </div>
                        ) : null}

                        <div className="deposit_proof_field">
                          <label htmlFor="deposit_proof_amount">Amount</label>
                          <div className="deposit_proof_input_wrap">
                            <input
                              id="deposit_proof_amount"
                              type="number"
                              min="0"
                              step="any"
                              placeholder="0.00"
                              value={proofAmount}
                              onChange={(e) => setProofAmount(e.target.value)}
                            />
                            <span className="deposit_proof_suffix">{selectedCurrency?.short_name || "Coin"}</span>
                          </div>
                          {(selectedCurrency?.min_deposit || selectedCurrency?.max_deposit) ? (
                            <small className="deposit_proof_limit">
                              {selectedCurrency?.min_deposit ? `Min ${selectedCurrency.min_deposit}` : ""}
                              {selectedCurrency?.min_deposit && selectedCurrency?.max_deposit ? " · " : ""}
                              {selectedCurrency?.max_deposit ? `Max ${selectedCurrency.max_deposit}` : ""}
                              {selectedCurrency?.short_name ? ` ${selectedCurrency.short_name}` : ""}
                            </small>
                          ) : null}
                        </div>
                        <div className="deposit_proof_field">
                          <label htmlFor="deposit_proof_hash">Transaction Hash</label>
                          <div className="deposit_proof_input_wrap">
                            <i className="ri-hashtag deposit_proof_input_icon"></i>
                            <input
                              id="deposit_proof_hash"
                              className="has-icon"
                              type="text"
                              placeholder="Paste transaction hash"
                              value={proofTxHash}
                              onChange={(e) => setProofTxHash(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="deposit_proof_field">
                          <label>Payment Screenshot</label>
                          <div className="deposit_proof_upload">
                            <input id="deposit_proof_file" type="file" accept="image/png,image/jpeg,image/jpg" onChange={handleProofScreenshot} />
                            {proofScreenshot ? (
                              <label htmlFor="deposit_proof_file" className="deposit_proof_upload_filled">
                                {proofPreview ? <img src={proofPreview} alt="screenshot preview" /> : <i className="ri-image-line"></i>}
                                <div className="deposit_proof_upload_copy">
                                  <strong>Screenshot selected</strong>
                                  <span>{proofScreenshot?.name}</span>
                                </div>
                                <em>Change</em>
                              </label>
                            ) : (
                              <label htmlFor="deposit_proof_file" className="deposit_proof_upload_empty">
                                <i className="ri-upload-cloud-2-line"></i>
                                <strong>Click to upload screenshot</strong>
                                <span>PNG or JPG, up to 2MB</span>
                              </label>
                            )}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="deposit_proof_submit"
                          onClick={handleSubmitDepositProof}
                          disabled={submittingProof}
                        >
                          {submittingProof ? "Submitting..." : "Submit Proof"}
                        </button>
                        <p className="deposit_proof_note">Deposits are reviewed after you submit. Keep the transaction hash handy.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="deposit_crypto_right">
            <h2>FAQ</h2>

            <div className="accordion accordion-flush" id="accordionFlushExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    How to deposit crypto?
                  </button>
                </h2>
                <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body">To deposit cryptocurrency, you need to send it from your external wallet to the deposit address provided by Vorienxlatform. Always double-check the address and network before confirming the transaction.</div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    How to Deposit Crypto Step-by-step Guide
                  </button>
                </h2>
                <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body"><ul>
                    <li><strong>Go to Deposit Section</strong> – Navigate to the deposit page on Vorienxlatform.</li>
                    <li><strong>Select Your Crypto</strong> – Choose the cryptocurrency you want to deposit.</li>
                    <li><strong>Copy the Deposit Address</strong> – Ensure you copy the correct address and network.</li>
                    <li><strong>Send Funds</strong> – Paste the address into your external wallet and send the amount.</li>
                    <li><strong>Wait for Confirmation</strong> – Blockchain transactions may take time depending on network congestion.</li>
                  </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    Deposit hasn't arrived?
                  </button>
                </h2>
                <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body"> <ul>
                    <li><strong>Check Transaction Status</strong> – Use a blockchain explorer to track the transaction.</li>
                    <li><strong>Verify the Network</strong> – Ensure you sent funds using the correct blockchain network.</li>
                    <li><strong>Confirm Minimum Deposit Amount</strong> – Some cryptocurrency have a minimum deposit limit.</li>
                    <li><strong>Contact Support</strong> – If it’s been a long time, reach out to customer support with transaction details.</li>
                  </ul></div>
                </div>
              </div>
            </div>
            <div className="news_announcement">
              <div className="announcements_top">
                <h2>Announcements</h2>
                <a href="/announcment_info">More &gt;</a>

              </div>
              {announcments?.length > 0 &&

                <marquee behavior="scroll" direction="down" scrollamount="3">

                  <div className="announcement_block">
                    {announcments?.map((item) => {
                      return (
                        <div>
                          <p>{item?.title}</p>

                          <span>{moment(item.updatedAt).format("DD-MM-YYYY  hh:ss A")}</span>

                        </div>
                      )
                    })}
                  </div>
                </marquee>
              }
            </div>
          </div>
        </div>

        <div className="recent_deposit_list">
          <div className="top_heading">
            <h4>Recent Deposits</h4>
            <div className="deposit_status_filters">
              {[
                { id: "", label: "All" },
                { id: "PENDING", label: "Pending" },
                { id: "COMPLETED", label: "Completed" },
                { id: "REJECTED", label: "Rejected" },
              ].map((tab) => (
                <button
                  key={tab.label}
                  type="button"
                  className={`deposit_status_filter ${depositStatusFilter === tab.id ? "active" : ""}`}
                  onClick={() => handleStatusFilter(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <div className="table_outer">
            <div className='table-responsive'>
              <table>
                <tbody>
                  {recentDepositHistory?.length > 0 ? recentDepositHistory?.map((item) => {
                    const shortTxHash = shortenAddress(item?.transaction_hash);
                    const coinName = item?.short_name || item?.currency || "--";
                    const filteredImageData = allCoinData?.filter((data) => data?.short_name === coinName)[0] || [];
                    return (
                      <tr key={item?._id || item?.transaction_hash}>
                        <td>
                          <div className="td_first">
                            <div className="price_heading">
                              <img width="30px" src={Object?.keys(filteredImageData)?.length > 0 ? ApiConfig?.baseImage + filteredImageData?.icon_path : ""} alt="" />
                              {coinName}
                            </div>
                            <div className="date_info"><span>Date</span>{moment(item.createdAt || item.updatedAt).format("DD-MM-YYYY  hh:ss A")}</div>
                          </div>
                        </td>
                        <td>Chain <span>{item?.chain || "--"}</span></td>
                        <td>Amount <span>{item?.amount} {coinName}</span></td>
                        <td>Tx Hash <div className="address_icon"><span>{shortTxHash || "----"}</span>
                          {shortTxHash ? (
                            <svg className="bn-svg icon-small-pointer mobile:icon-normal-pointer mobile:text-IconNormal"
                              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(item?.transaction_hash)}>
                              <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z"
                                fill="currentColor"></path></svg>
                          ) : null}
                        </div>
                        </td>
                        <td className="deposit_status_col">
                          <div className="deposit_status_row">
                            Status
                            <span className={`deposit_status_badge ${depositStatusClass(item?.status)}`}>
                              {depositStatusLabel(item?.status)}
                            </span>
                          </div>
                        </td>
                        <td onClick={() => handleDepositModal(item)}>View</td>
                      </tr>
                    )
                  }) : <tr rowSpan="5 " className='justify-content-center'>
                    <td colSpan="12">
                      <div className="no_data_outer">
                        <div className="no_data_vector">
                          <img src="/images/no_data_vector.svg" alt="no-data" />
                        </div>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>}
                </tbody>
              </table>
            </div>
          </div>
          {/* <!-- Modal table recent Pop Up Start --> */}
          <div className="modal fade search_form table_pop_up" id="recent_table" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h2>Deposit Details</h2>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="hot_trading_t">
                    <div className='table-responsive'>
                      <table>
                        <tbody>
                          <tr>
                            <td>Status</td>
                            <td className="right_t price_tb">
                              <span className={`deposit_status_badge ${depositStatusClass(modalData?.status)}`}>
                                {depositStatusLabel(modalData?.status)}
                              </span>
                            </td>
                          </tr>
                          {depositStatusKey(modalData?.status) === "REJECTED" && (modalData?.reject_reason || modalData?.rejection_reason || modalData?.reason) ? (
                            <tr>
                              <td>Reject reason</td>
                              <td className="right_t price_tb">{modalData?.reject_reason || modalData?.rejection_reason || modalData?.reason}</td>
                            </tr>
                          ) : null}
                          <tr>
                            <td>Date</td>
                            <td className="right_t price_tb">{moment(modalData?.createdAt || modalData?.updatedAt).format("DD-MM-YYYY  hh:ss A")}</td>
                          </tr>
                          <tr>
                            <td>Coin</td>
                            <td className="right_t price_tb">{modalData?.short_name || modalData?.currency}</td>
                          </tr>
                          <tr>
                            <td>Deposit amount</td>
                            <td className="right_t price_tb">{modalData?.amount} {modalData?.short_name || modalData?.currency}</td>
                          </tr>
                          <tr>
                            <td>Network</td>
                            <td className="right_t price_tb">{modalData?.chain || "--"}</td>
                          </tr>
                          <tr>
                            <td>Deposit Address</td>
                            <td className="right_t price_tb"><div className="address_icon"><span>{modalData?.shortToAddress || "----"}</span>
                              {modalData?.to_address ? (
                              <svg className="bn-svg icon-small-pointer mobile:icon-normal-pointer mobile:text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.to_address)}>
                                <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path></svg>
                              ) : null}
                            </div></td>
                          </tr>
                          <tr>
                            <td>TxID</td>
                            <td className="right_t price_tb"><div className="address_icon"><span>{modalData?.shortTxHash || "----"}</span>
                              {modalData?.transaction_hash ? (
                              <svg className="bn-svg icon-small-pointer mobile:icon-normal-pointer mobile:text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.transaction_hash)}>
                                <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path></svg>
                              ) : null}</div></td>
                          </tr>
                          <tr>
                            <td>Deposit wallet</td>
                            <td className="right_t price_tb">{modalData?.wallet_type === "spot" ? "Spot Wallet" : (modalData?.description?.includes("bonus") ? "Bonus Wallet" : "Spot Wallet")}</td>
                          </tr>
                          <tr>
                            <td>Description</td>
                            <td className="right_t price_tb">{modalData?.description}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* <p className="help_chat"><a href="/user_profile/support">Help? Chat with us</a></p> */}

                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Modal  table recent Pop Up End --> */}

        </div>
      </div>
    </>
  )
}

export default DepositPage
